import { ThumbUpOutlineIcon } from './ThumbUpOutlineIcon';

/**
 * author: Google
 * id BFA3B3A3-0D00-459A-8BDB-DAC2D4233023
 * name thumb-up-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/thumb-up-outline.svg
 * tags
 */
export const ThumbsUpOutlineIcon = ThumbUpOutlineIcon;
export default ThumbsUpOutlineIcon